import type { SocialProfile } from "@/types/social";

export const socialLinks = {
    instagram: "https://www.instagram.com/thequalityexports",
    linkedin: "https://www.linkedin.com/company/thequalitycollection",
    facebook: "https://www.facebook.com/thequalitycollection",
    x: "https://x.com/tqcollection",
};

export const socialProfiles: SocialProfile[] = [
    {
        id: "ig-profile",
        platform: "instagram",
        embedUrl: "https://www.instagram.com/thequalityexports/embed",
        title: "Instagram",
        caption: "Behind-the-scenes, process shots and new arrivals.",
        href: "https://www.instagram.com/thequalityexports",
    },
    {
        id: "li-profile",
        platform: "linkedin",
        embedUrl: "https://www.linkedin.com/embed/feed/update/urn:li:company:thequalitycollection",
        title: "LinkedIn",
        caption: "Trade updates, export milestones and craft dispatches.",
        href: "https://www.linkedin.com/company/thequalitycollection",
    },
    {
        id: "fb-profile",
        platform: "facebook",
        embedUrl: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fthequalitycollection&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
        title: "Facebook",
        caption: "Collection drops, bench days and community highlights.",
        href: "https://www.facebook.com/thequalitycollection",
    },
    {
        id: "x-profile",
        platform: "x",
        embedUrl: "https://syndication.twitter.com/srv/timeline-profile/screen-name/tqcollection?theme=light&dnt=true&chrome=noheader%20nofooter%20transparent",
        title: "X (Twitter)",
        caption: "Quick notes, packaging shots and studio observations.",
        href: "https://x.com/tqcollection",
    },
];